import React from "react";
import { FormattedMessage } from "react-intl";

function TrueFalseCell({ cell: { value } }) {
    return <FormattedMessage id="app.yes_no" values={{ value }} />;
}

export default TrueFalseCell;